import React from "react";
import Currecy from "../../service/Currency";
import translate from "../../service/Language";
import classes from "./Cart.module.css";

function Cart({
  productsInCart,
  setToggle,
  totalCoastGet,
  minusNumber,
  cartNumbers,
  setCheckout,
  setMediaBars,
  smallNavbarFalse
}) {


  return (
    <>
      <div className={classes.Cart}>
        <div className={classes.Cart_header}>
          <span>{translate("КОРЗИНА", "SAVAT")}</span>
          <div className={classes.line}></div>
          <div
            className={classes.close}
            onClick={(e) => {
              setToggle(false);
              setMediaBars(true)
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 13L13 1" stroke="black" strokeWidth="2"></path>
              <path d="M13 13L1 1" stroke="black" strokeWidth="2"></path>
            </svg>
          </div>
        </div>
        <div className={classes.Cart_products}>
          {productsInCart ?
            Object.values(JSON.parse(productsInCart)).length ? (
              Object.values(JSON.parse(productsInCart)).map((item, index) => (
                <div className={classes.product} key={index}>
                  <div className={classes.product_img}>
                    <img src={item.images[0].img} alt="" />
                  </div>
                  <div className={classes.product_desc}>
                    <h3>
                      {translate(
                        item.title_ru.slice(0, 99) + "...",
                        item.title_uz.slice(0, 99) + "..."
                      )}
                    </h3>
                    <div className={classes.Card_sizes}>
                      <div
                        className={classes.Card_minus}
                        onClick={(e) => {
                          minusNumber(item);
                        }}
                      >
                        <svg
                          width="15"
                          height="1"
                          viewBox="0 0 15 1"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="15" height="1" fill="#D8D7D7"></rect>
                        </svg>
                      </div>
                      <div className={classes.Card_num}>
                        <span>{item.inCart}</span>
                      </div>
                      <div
                        className={classes.Card_plus}
                        onClick={(e) => {
                          cartNumbers(item);
                        }}
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 14L14 1" stroke="#C5C0C0"></path>
                          <path d="M14 14L1 1" stroke="#C5C0C0"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className={classes.product_price}>
                    <span>{Currecy(item.price)} UZS</span>
                  </div>
                </div>
              ))
            ) : (
              <h2>{translate("Корзина пуста", "Savat bo'sh")}</h2>
            ) : <h2>{translate("Корзина пуста", "Savat bo'sh")}</h2>}
        </div>
        <div className={classes.Cart_footer}>
          <div className={classes.prices}>
            <span>{translate("ИТОГО:", "Barchasi:")}</span>
            <div className={classes.line}></div>
            <p>{Currecy(totalCoastGet)} UZS</p>
          </div>
          {productsInCart ? Object.values(JSON.parse(productsInCart)).length ? <button onClick={(e) => {
            setCheckout(true)
            setMediaBars(true)
            setToggle(false);
            smallNavbarFalse()
          }}>{translate("ОФОРМИТЬ ЗАКАЗ", "Buyurtmani boshlash")}</button> : "" : ""}
        </div>
      </div>
    </>
  );
}

export default Cart;
